export const vehicles = [
  {
    vehicle_identification: {
      vin: '5FNRL5H64GB111411',
    },
    mileage: {
      annual: 18000,
    },
    ownership_type: 'owned',
    vehicle_usage: 'commute',
    is_used_for_rideshare: false,
    anti_theft: ['none'],
    vehicle_coverages: {
      comprehensive: {
        deductible_key: 'one_hundred',
      },
      collision: {
        deductible_key: 'one_hundred',
      },
      rental: {
        limit_key: 'fifty_fifteen_hundred',
      },
      roadside: {
        waived: false,
      },
      rideshare: {
        waived: true,
      },
      uninsured_motorist_property_damage: {
        waived: true,
      },
    },
  },
  {
    vehicle_identification: {
      vin: 'JH4KA7674PC011688',
    },
    mileage: {
      annual: 18000,
    },
    ownership_type: 'owned',
    vehicle_usage: 'commute',
    is_used_for_rideshare: false,
    anti_theft: ['none'],
    vehicle_coverages: {
      comprehensive: {
        deductible_key: 'five_hundred',
      },
      collision: {
        deductible_key: 'five_hundred',
      },
      rental: {
        limit_key: 'thirty_nine_hundred',
      },
      roadside: {
        waived: false,
      },
      rideshare: {
        waived: true,
      },
      uninsured_motorist_property_damage: {
        waived: true,
      },
    },
  },
  {
    vehicle_identification: {
      vin: '1j46a44s255jg6jnp',
    },
    mileage: {
      annual: 10000,
    },
    vehicle_usage: 'commute',
    ownership_type: 'owned',
    is_used_for_rideshare: false,
    anti_theft: ['none'],
    vehicle_coverages: {
      comprehensive: {
        waived: true,
      },
      collision: {
        waived: true,
      },
      rental: {
        waived: true,
      },
      roadside: {
        waived: false,
      },
      rideshare: {
        waived: true,
      },
      uninsured_motorist_property_damage: {
        limit_key: 'thirty_five_hundred',
      },
    },
  },
  {
    vehicle_identification: {
      vin: '1C4GP54G4XB594007',
    },
    mileage: {
      annual: 18000,
    },
    ownership_type: 'owned',
    vehicle_usage: 'commute',
    is_used_for_rideshare: false,
    anti_theft: ['none'],
    vehicle_coverages: {
      comprehensive: {
        deductible_key: 'five_hundred',
      },
      collision: {
        deductible_key: 'five_hundred',
      },
      rental: {
        limit_key: 'fifty_fifteen_hundred',
      },
      roadside: {
        waived: false,
      },
      rideshare: {
        waived: true,
      },
      uninsured_motorist_property_damage: {
        waived: true,
      },
    },
  },
  {
    vehicle_identification: {
      vin: '1HGEJ2223SL062542',
    },
    mileage: {
      annual: 18000,
    },
    ownership_type: 'owned',
    vehicle_usage: 'commute',
    is_used_for_rideshare: false,
    anti_theft: ['none'],
    vehicle_coverages: {
      comprehensive: {
        deductible_key: 'one_hundred',
      },
      collision: {
        deductible_key: 'one_hundred',
      },
      rental: {
        limit_key: 'fifty_fifteen_hundred',
      },
      roadside: {
        waived: false,
      },
      rideshare: {
        waived: true,
      },
      uninsured_motorist_property_damage: {
        waived: true,
      },
    },
  },
];
